const query = (id, isPreview) => `
{
  mdlzNewsSearch(id: "${id}", preview: ${isPreview}){
    title
    datesCollection{
      items{
        ...on SearchMdlzNews{
          title
          dates
          
    description
   
    urls{
      url
    }
        }
      }
    }
  }
}
`
module.exports = { query }
